import React, { useState } from 'react';
import { motion } from 'framer-motion';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    industry: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here we would typically send data to backend
    console.log('Form submitted:', formData);
    
    // Reset form after submission
    setFormData({
      name: '',
      email: '',
      industry: '',
    });
    
    // Show success message or redirect
    alert("Thanks for your interest! We'll be in touch soon.");
  };

  return (
    <motion.form
      onSubmit={handleSubmit}
      className="w-full max-w-md mx-auto"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
    >
      <div className="mb-4">
        <label htmlFor="name" className="block text-white text-sm font-medium mb-2">
          Full Name
        </label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          className="w-full px-4 py-3 rounded-xl bg-white/10 backdrop-blur-sm border border-white/20 text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-white/50"
          placeholder="Enter your name"
          required
        />
      </div>

      <div className="mb-4">
        <label htmlFor="email" className="block text-white text-sm font-medium mb-2">
          Email Address
        </label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          className="w-full px-4 py-3 rounded-xl bg-white/10 backdrop-blur-sm border border-white/20 text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-white/50"
          placeholder="Enter your email"
          required
        />
      </div>

      <div className="mb-6">
        <label htmlFor="industry" className="block text-white text-sm font-medium mb-2">
          Industry
        </label>
        <select
          id="industry"
          name="industry"
          value={formData.industry}
          onChange={handleChange}
          className="w-full px-4 py-3 rounded-xl bg-white/10 backdrop-blur-sm border border-white/20 text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-white/50"
          required
        >
          <option value="" disabled className="text-neutral-700">Select your industry</option>
          <option value="real-estate" className="text-neutral-700">Real Estate</option>
          <option value="startup" className="text-neutral-700">Startup</option>
          <option value="ecommerce" className="text-neutral-700">E-Commerce</option>
          <option value="consulting" className="text-neutral-700">Consulting</option>
          <option value="other" className="text-neutral-700">Other</option>
        </select>
      </div>

      <a 
        href="https://calendly.com/adam-cothes/va-consultation" 
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-primary bg-white text-primary-700 hover:bg-primary-50 py-3 px-6 rounded-xl font-semibold transition-all duration-200"
      >
        Book a Call
      </a>
    </motion.form>
  );
};

export default ContactForm;